/**
 * Legacy Header - replaced by <UnifiedNav /> (mounted globally in App.js).
 * This component now renders ONLY a top spacer so pages that still import
 * and render <Header /> keep their correct vertical spacing under the
 * floating top pill. Kept as a thin shim to avoid refactoring every page.
 */
export default function Header() {
  // Height of the floating top pill + its top padding + iOS safe-area-inset-top.
  // pt-3 (12) + 48 (h-12) = ~60px on mobile
  // sm: pt-4 (16) + 56 (h-14) = ~72px on desktop
  // Plus env(safe-area-inset-top) for iPhone notch/Dynamic Island.
  return (
    <div
      aria-hidden="true"
      className="pt-safe"
      data-testid="header-spacer"
    >
      {/* Extra offset while the Donaris promo bar is visible (set by DonarisPromoBar) */}
      <div style={{ height: "var(--donaris-h, 0px)" }} />
      <div className="h-16 sm:h-20" />
    </div>
  );
}
